import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Services } from "@/components/sections/Services";
import { DigitalTwin } from "@/components/sections/DigitalTwin";
import { AIWorkflow } from "@/components/sections/AIWorkflow";
import { Teams } from "@/components/sections/Teams";
import { Pricing } from "@/components/sections/Pricing";
import { Partnership } from "@/components/sections/Partnership";
import { IndustriesSecurity } from "@/components/sections/IndustriesSecurity";
import { DocsResources } from "@/components/sections/DocsResources";
import { Engagements } from "@/components/sections/Engagements";

export default function Landing() {
  return (
    <div className="bg-background min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <DigitalTwin />
        <AIWorkflow />
        <Teams />
        <Pricing />
        <Partnership />
        <IndustriesSecurity />
        <Engagements />
        <DocsResources />
      </main>
      <Footer />
    </div>
  );
}
